import { appVersion } from './version'

export const environment = {
  production: true,
  environmentName: 'Homolog',
  baseUrl: 'http://api.tgmob.preprod.prolins.com.br/api/',
  googleMapsApiKey: 'AIzaSyA9sanaPLa3B7FntR9EUMdI3ZojdbWoSHg',
  version: appVersion,
  // baseUrl: 'http://api.tgmob-dev.prolins.com.br/api/',
}
